import { render, staticRenderFns } from "./Overduelist.vue?vue&type=template&id=0c706c4a&scoped=true&"
import script from "./Overduelist.vue?vue&type=script&lang=js&"
export * from "./Overduelist.vue?vue&type=script&lang=js&"
import style0 from "./Overduelist.vue?vue&type=style&index=0&id=0c706c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c706c4a",
  null
  
)

export default component.exports